<div class="container h-100 d-flex align-items-center p-5" *ngIf="isCustomPlansLoading">
  <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>
<div class="container p-5" *ngIf="!isCustomPlansLoading">
  <div class="row">
    <h1 class="mb-0">Pricing plans</h1>
    <h4 class="fw-light mb-0">Pricing Solutions Designed For Your Specific Needs</h4>
  </div>

  <mat-divider class="mt-4 mb-4"></mat-divider>

  <div class="col-12 d-flex justify-content-end">
    <button mat-raised-button class="d-block mt-4" (click)="openDiscountCodeDialog()">Enter discount code</button>
 </div>

  <div class="row mt-5">
    <div *ngIf="isSubaccount && customPaymentPlans">
      <app-custom-payment-plan class="mx-auto" style="width: 85%;" [isPurchaseMode]="true"
        [plans]="customPaymentPlans"></app-custom-payment-plan>
    </div>
    <div class="container" *ngIf="!isSubaccount">
      <div class="row">
        <div class="col-4 mb-5" *ngFor="let plan of paymentPlans; let i = index">
          <div class="mat-elevation-z2 rounded p-3">
            <h1 class="text-center mb-0">{{ plan.title }}</h1>

            <mat-divider class="mt-3 mb-4"></mat-divider>

            <h2><span style="font-size: xx-large;">${{ plan.price }}</span> <span class="fw-light"
                style="font-size: medium;"> per month</span>
            </h2>
            <button [disabled]="isLoadingForAll || isLoading[i] || plan.buttonText == currentPlanString"
              (click)="onPaymentPlanSelection(plan.paymentPlan, i)" mat-raised-button class="d-block text-center w-100">
              <span *ngIf="!isLoading[i]">
                {{ plan.buttonText }}
              </span>
              <mat-spinner *ngIf="isLoading[i]" [diameter]="30" [strokeWidth]="3"
                class="mx-auto mat-spinner"></mat-spinner>
            </button>

            <mat-divider class="mt-3 mb-3"></mat-divider>

            <h3 class="mt-0 text-secondary">COSTS STRUCTURE</h3>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Minutes Included</p>
              <p>{{ plan.costStructure.minutesIncluded }}</p>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Additional costs/min</p>
              <p>${{ plan.costStructure.additionalCostsPerMin.toFixed(2) }}</p>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Assistants</p>
              <p>{{ plan.nbAssistants }}</p>
            </div>

            <p class="text-secondary">Includes inbound and outbound calls</p>

            <mat-divider class="mt-3 mb-3"></mat-divider>

            <h3 class="mt-0 text-secondary">WHITE LABEL</h3>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Whitelabel</p>
              <mat-icon
                [ngClass]="{'text-success' : plan.whiteLabel.whiteLabel, 'text-danger' : !plan.whiteLabel.whiteLabel}">{{
                plan.whiteLabel.whiteLabel
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Rebilling</p>
              <mat-icon
                [ngClass]="{'text-success' : plan.whiteLabel.rebilling, 'text-danger' : !plan.whiteLabel.rebilling}">{{
                plan.whiteLabel.rebilling
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <mat-divider class="mt-3 mb-3"></mat-divider>

            <h3 class="mt-0 text-secondary">ACTIONS</h3>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">SMS</p>
              <mat-icon [ngClass]="{'text-success' : plan.actions.sms, 'text-danger' : !plan.actions.sms}">{{
                plan.actions.sms
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Real-Time Booking</p>
              <mat-icon [ngClass]="{'text-success' : plan.actions.booking, 'text-danger' : !plan.actions.booking}">{{
                plan.actions.booking
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <mat-divider class="mt-3 mb-3"></mat-divider>

            <h3 class="mt-0 text-secondary">INTEGRATIONS</h3>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Zapier</p>
              <mat-icon
                [ngClass]="{'text-success' : plan.integrations.zapier, 'text-danger' : !plan.integrations.zapier}">{{
                plan.integrations.zapier
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Cal</p>
              <mat-icon [ngClass]="{'text-success' : plan.integrations.cal, 'text-danger' : !plan.integrations.cal}">{{
                plan.integrations.cal
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <mat-divider class="mt-3 mb-3"></mat-divider>

            <h3 class="mt-0 text-secondary">SUPPORT</h3>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">White-glove onboarding</p>
              <mat-icon
                [ngClass]="{'text-success' : plan.support.whiteGloveOnboarding, 'text-danger' : !plan.support.whiteGloveOnboarding}">{{
                plan.support.whiteGloveOnboarding
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Dedicated support manager</p>
              <mat-icon
                [ngClass]="{'text-success' : plan.support.dedicatedSupportManager, 'text-danger' : !plan.support.dedicatedSupportManager}">{{
                plan.support.dedicatedSupportManager
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>

            <div class="d-flex justify-content-between">
              <p class="fw-bold">Early release features</p>
              <mat-icon
                [ngClass]="{'text-success' : plan.support.earlyReleaseFeatures, 'text-danger' : !plan.support.earlyReleaseFeatures}">{{
                plan.support.earlyReleaseFeatures
                ? 'check' : 'clear'
                }}
              </mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>